
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SingleTableModel, LastEvaluatedKey } from '../models/singleTableModel';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { Search } from '../models/searchModel';

@Injectable({ providedIn: 'root' })
export class BillingService {

  pageData: any = [];
  constructor(private http: HttpClient, private authService: AuthService) {
    console.log(this.headers);
  }

  headers = {
    'Authorization': this.authService.Authorization$.value,
    //'LoggedInUserAccessKey': this.authService.AccessDetails$.value.AccessKey
  };
  httpOptions = {
    headers: this.headers
  };

  setheader() {
    this.headers.Authorization = this.authService.Authorization$.value;
    //this.headers.LoggedInUserAccessKey = this.authService.AccessDetails$.value.AccessKey;
    this.httpOptions.headers = this.headers;
  }

  
  searchByTransactionId(searchData: Search): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("case", searchData.searchCase)
      .set("tenantId", searchData.tenantId)
      .set("transactionId", searchData.transactionId);
    console.log(this.headers);
    return this.http.get(environment.billingURL.replace('#hostname#', this.authService.hostName$.value).replace('#stagename#', this.authService.stage$.value).replace('#tenantId#', this.authService.tenantId$.value) + '/getTransactionsAfterGivenTransactionId', {
      'params': params, 'headers': this.headers } );
  }

  searchByTransactionIdWithLimit(searchData: Search): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("case", searchData.searchCase)
      .set("tenantId", searchData.tenantId)
      .set("transactionId", searchData.transactionId)
      .set("lekTenantId", searchData.lastEvaluatedKey.tenantId)
      .set("lekTransactionId", searchData.lastEvaluatedKey.transactionId);
    console.log(this.headers);
    return this.http.get(environment.billingURL.replace('#hostname#', this.authService.hostName$.value).replace('#stagename#', this.authService.stage$.value).replace('#tenantId#', this.authService.tenantId$.value) +'/getTransactionsAfterGivenTransactionId', {
      'params': params, 'headers': this.headers
    });
  }

  searchByDate(searchData: Search): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("tenantId", searchData.tenantId)
      .set("fromDate", searchData.fromDate)
      .set("toDate", searchData.toDate);
    return this.http.get(environment.billingURL.replace('#hostname#', this.authService.hostName$.value).replace('#stagename#', this.authService.stage$.value).replace('#tenantId#', this.authService.tenantId$.value) +'/getTransactionsInGivenTimePeriod', { 'params': params, 'headers': this.headers });
  }

  searchByDateWithLimit(searchData: Search): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("tenantId", searchData.tenantId)
      .set("fromDate", searchData.fromDate)
      .set("toDate", searchData.toDate)
      .set("lekTenantId", searchData.lastEvaluatedKey.tenantId)
      .set("lekTransactionId", searchData.lastEvaluatedKey.transactionId)

    return this.http.get(environment.billingURL.replace('#hostname#', this.authService.hostName$.value).replace('#stagename#', this.authService.stage$.value).replace('#tenantId#', this.authService.tenantId$.value) + '/getTransactionsInGivenTimePeriod', { 'params': params, 'headers': this.headers });
  }

}
